import hashSum from 'hash-sum';
import PropTypes from 'prop-types';

import TagCloseButton from './TagCloseButton';

import './styles.css';

const colors = [
  'bg-blue-1',
  'bg-cyan-2',
  'bg-gray-2',
  'bg-green-1',
  'bg-orange-1',
  'bg-orange-2',
  'bg-purple-1',
  'bg-purple-2',
  'bg-red-1',
  'bg-teal-2',
  'bg-yellow-2',
  'bg-yellow-3',
];

const childrenToColor = (children) => {
  const pos = parseInt(hashSum(children), 16);
  const color = colors[pos % colors.length];
  return `${color} text-gray-6`;
};

const RandomColorTag = ({ children, onClose, ...props }) => (
  <span
    {...props}
    className={`tag inline-flex flex-row items-center justify-center rounded ${childrenToColor(
      children,
    )}`}
  >
    <span
      className="tag-truncated text-ellipsis overflow-hidden whitespace-nowrap"
      title={children}
    >
      {children}
    </span>
    {onClose && <TagCloseButton callback={onClose} className="text-gray-3" />}
  </span>
);

RandomColorTag.defaultProps = {
  onClose: null,
};

RandomColorTag.propTypes = {
  children: PropTypes.string.isRequired,
  onClose: PropTypes.func,
};

export default RandomColorTag;
